/** A forbidden action is not necessarily a credit shortage. Only explicit 402 qualifies. */
export function isGenerationCreditError(value) {
  return [value?.code, value?.response?.status, value?.response?.data?.code].includes(402);
}
